import React, {Component} from 'react';

import {Link} from 'components/ReactRouterDomLocalized';
import {dt} from '../../l10n';
import {getPaymentUrl} from 'utils/url';

export default function XXLFunctionsText({className, showLink = true}) {
    return (
        <div className="content">
            <div className="logo-wrapper">
                <div className="logo-outer">
                    <div className="logo">
                        <div className="header" dangerouslySetInnerHTML={{__html: dt('xxl', '<span class="XXL">XXL</span> Membership')}}/>
                        {showLink ? <Link to={getPaymentUrl()}>{dt('xxl', 'Click here to access XXL features')}</Link> : null}
                    </div>
                </div>
            </div> 
            <div className={className}>
                <p>{dt('xxl', 'Single payment, without automatic rebilling. Immediate access!')}</p>

                <div className="list">
                    <ul>
                        <li>{dt('xxl', 'Viewing all webcams without limits')}</li>
                        <li>{dt('xxl', 'Full-screen viewing of webcams')}</li>
                        <li>{dt('xxl', 'Private messages (PM) feature')}</li>
                        <li>{dt('xxl', 'Private room creation')}</li>
                        <li>{dt('xxl', 'Access to full rooms')}</li>
                        <li>{dt('xxl', 'All features in the mail')}</li>
                        <li>{dt('xxl', 'All features of the profile page')}</li>
                        <li>{dt('xxl', 'Access to all amateur videos')}</li>
                        <li>{dt('xxl', 'Access to all photos')}</li>
                        <li>{dt('xxl', 'Blocking unwanted users')}</li>
                        <li>{dt('xxl', 'Participation in collective moderation')}</li>
                        <li className="no-disc">{dt('xxl', 'And a lot more...')}</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/XXL/XXLFunctionsText.js